import { useCallback, useEffect, useRef, useState } from 'react';

const CLOSED = { msg: '', open: false, severity: '' };

// A transient message (shown through <AlertSnackbar />) that hides itself.
// showAlert(msg, severity, ms): severity is a MUI Alert severity; leave it out for the default.
export const useAlert = () => {
  const [errorAlert, setErrorAlert] = useState({ ...CLOSED, key: Math.random() });
  const timer = useRef(null);

  const showAlert = useCallback((msg, severity, ms = 3000) => {
    clearTimeout(timer.current);
    setErrorAlert({ msg, key: Math.random(), open: true, severity });
    timer.current = setTimeout(() => setErrorAlert({ ...CLOSED, key: Math.random() }), ms);
  }, []);

  // a pending hide must not fire into an unmounted component
  useEffect(() => () => clearTimeout(timer.current), []);

  return { errorAlert, setErrorAlert, showAlert };
};
